/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { TriggerEvent } from '../../models/trigger-event';
import { TriggerEventResponse } from '../../models/trigger-event-response';

export interface TriggerEvent$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: TriggerEvent
}

export function triggerEvent(http: HttpClient, rootUrl: string, params: TriggerEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<TriggerEventResponse>> {
  const rb = new RequestBuilder(rootUrl, triggerEvent.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TriggerEventResponse>;
    })
  );
}

triggerEvent.PATH = '/organization-sites/{organizationSiteKey}/events';
